
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#2F80ED"}}),_c('path',{attrs:{"d":"M21.625 27h-9.563c-.281 0-.551-.113-.75-.314-.2-.2-.312-.473-.312-.757V13.07c0-.284.112-.556.311-.757.2-.201.47-.314.752-.314h14.874c.282 0 .552.113.752.314.2.2.311.473.311.757V20.511","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.5 20a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM16 23c0-.796.369-1.559 1.025-2.121.657-.563 1.547-.879 2.475-.879.928 0 1.819.316 2.475.879C22.63 21.44 23 22.204 23 23","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30 24l-5 5M25 24l5 5","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    